<template>
	<div>
		<ul class="mb-200-md mb-100-smo">
			<li
				v-for="(item, i) in list"
				:key="i"
				:class="[
					{
						'mt-200': i !== 0,
						'bb border-color-reversed': i !== list.length - 1
					}
				]"
			>
				<h3 class="heading-2 font-weight-lighter text-color-white">
					<BaseLink v-if="item.link" :link="item.link" classes="item-link text-color-white mb-100">
						<img v-if="item.logoSrc" :src="item.logoSrc" :alt="item.heading" class="item-logo" />
						<span v-else>{{ item.heading }}</span>
						<BaseSvgIcon
							name="arrow"
							dir="up"
							height="36"
							width="36"
							class="ml-50 text-color-current-color"
						/>
					</BaseLink>
					<span v-else> {{ item.heading }}<sup class="body-sm">TM</sup></span>
				</h3>
				<p
					:class="[
						'text-color-gray-40 mt-50',
						{
							'mb-200': i !== list.length - 1
						}
					]"
					>{{ item.description }}</p
				>
			</li>
		</ul>
	</div>
</template>
<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import BaseLink from '@components/_base-link.vue';
import type { Link } from 'types/layout';

interface TechListItem {
	heading: string;
	description: string;
	logoSrc?: string;
	showTm?: boolean;
	link?: Link;
}

const list: Array<TechListItem> = [
	{
		heading: 'RealAI',
		description:
			'RealAI is ChatGPT for real estate data, offering professional-grade insight using more than 3 trillion data points',
		logoSrc: `${appCloudfrontPath}/images/marketing-site/logos/logo-real-ai-white.svg`,
		link: {
			href: 'https://www.realai.com',
			target: '_blank',
			rel: 'noopener noreferrer'
		}
	},
	{
		heading: 'Basis',
		description: 'An operating system for real estate asset management'
	},
	{
		heading: 'Cornice',
		description: 'An operating system for investor servicing and fund management'
	}
];
</script>
<style lang="scss" scoped>
.item-link {
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-decoration: none;
}

.item-logo {
	width: 150px;
}
</style>
